if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

$('.he_product-atc_long').click(function(evt){
    if (window._learnq && typeof window._learnq.push === 'function') {
      _learnq.push(['track', 'Added to Cart', item]);
      console.log('Added to cart to klaviyo sent');
    }

    // Collect product data
    var currentId = $('.he_product-variant-line_outer.active').attr('data-id');
    var currentSellingPlan = '';
    if ($('.he_product-sub-btn').hasClass('active')){
      currentSellingPlan = $('.he_product-variant-line_outer.active').attr('data-selling-plan');
    }
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    // Show loading state (optional)
    var $btn = $(this);
    $btn.attr('aria-disabled', true).addClass('loading');
    $btn.find('.loading-overlay__spinner').removeClass('hidden');

    // Prepare fetch config
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('id', currentId);
    formData.append('quantity', 1);
    if (currentSellingPlan) formData.append('selling_plan', currentSellingPlan);

    if (cart) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map(section => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(document.activeElement);
    }

    config.body = formData;

    // Perform fetch
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          // Handle errors
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'main_product-atc-btn',
            productVariantId: currentId,
            errors: response.errors || response.description,
            message: response.message,
          });
          // Optional: show error message to user
          return;
        }

        // Redirect if no cart drawer
        if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }

        // Successful cart add
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'main_product-atc-btn',
          productVariantId: currentId,
          cartData: response
        });

        cart.renderContents(response);
        $('.drawer').removeClass('is-empty');
      })
      .catch((e) => {
        console.error('Add to cart error:', e);
      })
      .finally(() => {
        $btn.removeClass('loading').removeAttr('aria-disabled');
        $btn.find('.loading-overlay__spinner').addClass('hidden');
      });
});


$('.he_product-atc').click(function(evt){
    if (window._learnq && typeof window._learnq.push === 'function') {
      _learnq.push(['track', 'Added to Cart', item]);
      console.log('Added to cart to klaviyo sent');
    }

    // Collect product data
    var currentId = $('.he_product-variant-box.active').attr('data-id');
    var currentSellingPlan = '';
    if ($('.he_product-sub-btn').hasClass('active')){
      currentSellingPlan = $('.he_product-variant-box.active').attr('data-selling-plan');
    }
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    // Show loading state (optional)
    var $btn = $(this);
    $btn.attr('aria-disabled', true).addClass('loading');
    $btn.find('.loading-overlay__spinner').removeClass('hidden');

    // Prepare fetch config
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('id', currentId);
    formData.append('quantity', 1);
    if (currentSellingPlan) formData.append('selling_plan', currentSellingPlan);

    if (cart) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map(section => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(document.activeElement);
    }

    config.body = formData;

    // Perform fetch
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          // Handle errors
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'main_product-atc-btn',
            productVariantId: currentId,
            errors: response.errors || response.description,
            message: response.message,
          });
          // Optional: show error message to user
          return;
        }

        // Redirect if no cart drawer
        if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }

        // Successful cart add
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'main_product-atc-btn',
          productVariantId: currentId,
          cartData: response
        });

        cart.renderContents(response);
        $('.drawer').removeClass('is-empty');
      })
      .catch((e) => {
        console.error('Add to cart error:', e);
      })
      .finally(() => {
        $btn.removeClass('loading').removeAttr('aria-disabled');
        $btn.find('.loading-overlay__spinner').addClass('hidden');
      });
});


$('.main_product-atc-btn').click(function(evt){
  evt.preventDefault();

  if (window._learnq && typeof window._learnq.push === 'function') {
    _learnq.push(['track', 'Added to Cart', item]);
    console.log('Added to cart to klaviyo sent');
  }
  
  // Collect product data
  var currentId = $('.mp_selection-box.active').attr('data-id');
  var currentSellingPlan = $('.mp_selection-box.active').attr('data-selling-plan');
  var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  // Show loading state (optional)
  var $btn = $(this);
  $btn.attr('aria-disabled', true).addClass('loading');
  $btn.find('.loading-overlay__spinner').removeClass('hidden');

  // Prepare fetch config
  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData();
  formData.append('id', currentId);
  formData.append('quantity', 1);
  if (currentSellingPlan) formData.append('selling_plan', currentSellingPlan);

  if (cart) {
    formData.append(
      'sections',
      cart.getSectionsToRender().map(section => section.id)
    );
    formData.append('sections_url', window.location.pathname);
    cart.setActiveElement(document.activeElement);
  }

  config.body = formData;

  // Perform fetch
  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        // Handle errors
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'main_product-atc-btn',
          productVariantId: currentId,
          errors: response.errors || response.description,
          message: response.message,
        });
        // Optional: show error message to user
        return;
      }

      // Redirect if no cart drawer
      if (!cart) {
        window.location = window.routes.cart_url;
        return;
      }

      // Successful cart add
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'main_product-atc-btn',
        productVariantId: currentId,
        cartData: response
      });

      cart.renderContents(response);
      $('.drawer').removeClass('is-empty');
    })
    .catch((e) => {
      console.error('Add to cart error:', e);
    })
    .finally(() => {
      $btn.removeClass('loading').removeAttr('aria-disabled');
      $btn.find('.loading-overlay__spinner').addClass('hidden');
    });
});



$('.main-product_atc_btn--js').click(function(evt){
  evt.preventDefault();

   if (window._learnq && typeof window._learnq.push === 'function') {
    _learnq.push(['track', 'Added to Cart', item]);
    console.log('Added to cart to klaviyo sent');
  }
  // // Collect product data
  var currentId = $('.arCf_variant.arCfVar_active').attr('data-id');
  var currentSellingPlan = $('.arCf_variant.arCfVar_active').attr('data-sellingplan');
  var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  var isSub = $('#subscribeAr').length ? $('#subscribeAr').is(':checked') : false;

  console.log(currentId , 'current id is');
  // // Show loading state (optional)
  // var $btn = $(this);
  // $btn.attr('aria-disabled', true).addClass('loading');
  // $btn.find('.loading-overlay__spinner').removeClass('hidden');

  // // Prepare fetch config
  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData();
  formData.append('id', currentId);
  formData.append('quantity', 1);
  if (isSub) formData.append('selling_plan', currentSellingPlan);

  if (cart) {
    formData.append(
      'sections',
      cart.getSectionsToRender().map(section => section.id)
    );
    formData.append('sections_url', window.location.pathname);
    cart.setActiveElement(document.activeElement);
  }

  config.body = formData;

  // // Perform fetch
  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        // Handle errors
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'main_product-atc-btn',
          productVariantId: currentId,
          errors: response.errors || response.description,
          message: response.message,
        });
        // Optional: show error message to user
        return;
      }

      // Redirect if no cart drawer
      if (!cart) {
        window.location = window.routes.cart_url;
        return;
      }

      // Successful cart add
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'main_product-atc-btn',
        productVariantId: currentId,
        cartData: response
      });

      cart.renderContents(response);
      $('.drawer').removeClass('is-empty');
    })
    .catch((e) => {
      console.error('Add to cart error:', e);
    })
    .finally(() => {
      $btn.removeClass('loading').removeAttr('aria-disabled');
      $btn.find('.loading-overlay__spinner').addClass('hidden');
    });

   
});


var discountCodes = '1BAGFREE';

  // Helper to build the redirect URL (works for multiple codes too)
  function checkoutWithDiscount(codes) {
    // Preferred pattern:
    // /discount/CODE1,CODE2?redirect=/checkout
    // (Shopify will apply combinable codes if your store allows it)
    var encoded = encodeURIComponent(codes);
    return '/discount/' + encoded + '?redirect=' + encodeURIComponent('/checkout');
    // Alternative (also works): return '/checkout?discount=' + encoded;
  }


// put this somewhere above your click handler
const discountCodesShipping = ['SHIPPING TRIAL']; // supports multiple codes if needed

function checkoutWithDiscountCodeShip(codes) {
  const encoded = codes.map(c => encodeURIComponent(c.trim())).join(',');
  return `/checkout?discount=${encoded}`;
}

$('.col_simple-buy-atc-btn').click(function(){
  var currentId = $(this).attr('data-id');
  var sellingPlan = $(this).attr('data-sub-id');
  var quantityCur = 1;

  $.ajax({
    type: "POST",
    url: "/cart/clear.js",
    success: function () {
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          id: currentId,
          quantity: quantityCur,
          selling_plan: sellingPlan
        },
        success: function () {
          window.location.href = checkoutWithDiscountCodeShip(discountCodesShipping);
        }
      });
    }
  });
});


// $('.col_simple-buy-atc-btn').click(function(evt){
//   evt.preventDefault();

//   console.log('clicked atc btn')
//   // Collect product data
//   var currentId = $(this).attr('data-id');
//   var currentSellingPlan = $('.mp_selection-box.active').attr('data-selling-plan');

//   var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

//   // Show loading state (optional)
//   var $btn = $(this);
//   $btn.attr('aria-disabled', true).addClass('loading');
//   $btn.find('.loading-overlay__spinner').removeClass('hidden');

//   // Prepare fetch config
//   const config = fetchConfig('javascript');
//   config.headers['X-Requested-With'] = 'XMLHttpRequest';
//   delete config.headers['Content-Type'];

//   const formData = new FormData();
//   formData.append('id', currentId);
//   formData.append('quantity', 1);
//   if (currentSellingPlan) formData.append('selling_plan', currentSellingPlan);

//   if (cart) {
//     formData.append(
//       'sections',
//       cart.getSectionsToRender().map(section => section.id)
//     );
//     formData.append('sections_url', window.location.pathname);
//     cart.setActiveElement(document.activeElement);
//   }

//   config.body = formData;

//   // Perform fetch
//   fetch(`${routes.cart_add_url}`, config)
//     .then((response) => response.json())
//     .then((response) => {
//       if (response.status) {
//         // Handle errors
//         publish(PUB_SUB_EVENTS.cartError, {
//           source: 'main_product-atc-btn',
//           productVariantId: currentId,
//           errors: response.errors || response.description,
//           message: response.message,
//         });
//         // Optional: show error message to user
//         return;
//       }

//       // Redirect if no cart drawer
//       if (!cart) {
//         window.location = window.routes.cart_url;
//         return;
//       }

//       // Successful cart add
//       publish(PUB_SUB_EVENTS.cartUpdate, {
//         source: 'main_product-atc-btn',
//         productVariantId: currentId,
//         cartData: response
//       });

//       cart.renderContents(response);
//       $('.drawer').removeClass('is-empty');
//     })
//     .catch((e) => {
//       console.error('Add to cart error:', e);
//     })
//     .finally(() => {
//       $btn.removeClass('loading').removeAttr('aria-disabled');
//       $btn.find('.loading-overlay__spinner').addClass('hidden');
//     });
// });